module.exports = __webpack_public_path__ + "static/media/test-blur.532c3830.jpg";